import NotificationAcceptedItem from "./NotificationAcceptedItem";
import NotificationRefusedItem from "./NotificationRefusedItem";
import NotificationProposalItem from "./NotificationProposalItem";
import NotificationRouteDeviationItem from "./NotificationRouteDeviationItem";
import NotificationAvoidAreaItem from "./NotificationAvoidAreaItem";
import NotificationInterestAreaItem from "./NotificationInterestAreaItem";
import NotificationRouteSuggestionItem from "./NotificationRouteSuggestionItem";

export const NotificationItem = {
    NotificationAcceptedItem,
    NotificationRefusedItem,
    NotificationProposalItem,
    NotificationRouteDeviationItem,
    NotificationAvoidAreaItem,
    NotificationInterestAreaItem,
    NotificationRouteSuggestionItem,
}